import AvatarCat from '@svg/avatar_cat.svg';
import PointingAvatarCat from '@svg/pointing_avatar_cat.svg';
import WelcomeAvatarCat from '@svg/welcome_avatar_cat.svg';
export type CatImageVariantT = 'welcome' | 'pointing' | 'avatar';
export type ImagePropsT = {
  src: string;
  alt: string;
};

export const catDictionary: Record<CatImageVariantT, ImagePropsT> = {
  welcome: {
    src: WelcomeAvatarCat.src,
    alt: 'Bice Vida Welcome Cat',
  },
  pointing: {
    src: PointingAvatarCat.src,
    alt: 'Bice Vida Pointing Cat',
  },
  avatar: {
    src: AvatarCat.src,
    alt: 'Bice Vida Avatar Cat',
  },
};
